/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Surface lifecycle status
 * @export
 */
export const SurfaceStatus = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    ARCHIVED: 'ARCHIVED'
} as const;
export type SurfaceStatus = typeof SurfaceStatus[keyof typeof SurfaceStatus];


export function instanceOfSurfaceStatus(value: any): boolean {
    for (const key in SurfaceStatus) {
        if (Object.prototype.hasOwnProperty.call(SurfaceStatus, key)) {
            if (SurfaceStatus[key as keyof typeof SurfaceStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SurfaceStatusFromJSON(json: any): SurfaceStatus {
    return SurfaceStatusFromJSONTyped(json, false);
}

export function SurfaceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceStatus {
    return json as SurfaceStatus;
}

export function SurfaceStatusToJSON(value?: SurfaceStatus | null): any {
    return value as any;
}

export function SurfaceStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SurfaceStatus {
    return value as SurfaceStatus;
}

